<p-breadcrumb [model]="displayItems()">
  <ng-template
    #item
    let-item
    let-last="last"
  >
    @if (item.id === '__ellipsis__') {
      <!-- Mobile: collapsed parents — click opens the popup menu -->
      <button
        type="button"
        [class]="'cursor-pointer text-secondary transition-colors bg-transparent border-none p-0 ' + item.styleClass"
        (click)="toggleMenu($event)"
        (keydown.enter)="toggleMenu($event)"
        (keydown.space)="toggleMenu($event)"
        aria-label="More options"
      >
        <i class="pi pi-ellipsis-h text-sm"></i>
      </button>
    } @else if (item.id === '__last__') {
      <!-- Current / last item -->
      <span [class]="'text-sm font-semibold text-secondary ' + item.styleClass">{{ item.label }}</span>
    } @else {
      <!-- Parent item -->
      @if (item.routerLink) {
        <a
          [routerLink]="item.routerLink"
          [class]="'text-sm text-secondary cursor-pointer transition-colors ' + item.styleClass"
        >
          {{ item.label }}
        </a>
      } @else {
        <span [class]="'text-sm text-secondary ' + item.styleClass">{{ item.label }}</span>
      }
    }
  </ng-template>
</p-breadcrumb>

<!-- Mobile popup menu with all parent routes -->
<p-menu
  #menu
  [model]="mobileMenuItems()"
  [popup]="true"
  appendTo="body"
/>
